module.exports = __webpack_public_path__ + "img/40_69_002_840.fc3854b4.jpg";